import React from 'react';
import './ShootingStars.css';

const ShootingStars: React.FC = () => {
    // Generate a few stars with random properties
    // Using a few more stars to ensure they are seen occasionally
    const stars = Array.from({ length: 6 });

    return (
        <div className="shooting-stars-container">
            {stars.map((_, index) => {
                const top = Math.random() * 60; // Mostly top half
                const left = Math.random() * 100;
                const delay = Math.random() * 10; // 0-10s initial delay
                const duration = Math.random() * 3 + 3; // 3-6s duration per cycle

                return (
                    <div
                        key={index}
                        className="shooting-star-wrapper"
                        style={{
                            top: `${top}%`,
                            left: `${left}%`,
                            transform: `rotate(${Math.random() * 30 + 30}deg)`, // ~30-60 degrees tilt
                        }}
                    >
                        <div
                            className="shooting-star"
                            style={{
                                animationDelay: `${delay}s`,
                                animationDuration: `${duration}s`,
                            }}
                        />
                    </div>
                );
            })}
        </div>
    );
};

export default ShootingStars;
